import { FC, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { useFilters } from "@context/filter";
import { ActionType } from "@interfaces/filters";
import { createQuery } from "@lib/filters";
import Loader from "@components/common/loader";

const FilterButtons: FC = () => {
  const { filters, dispatch } = useFilters();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("category");

  const handleClick = async (clear?: boolean) => {
    let query = { slug: router.query["slug"], ...createQuery(filters) };

    if (clear) {
      dispatch({ type: ActionType.RESET });
      query = { slug: router.query["slug"] };
    }

    setLoading(true);
    await router.push({
      pathname: router.pathname,
      query,
    });
    router.reload();
  };

  return (
    <div className="flex flex-row justify-center space-x-4">
      <Loader {...{ loading }} />
      <button
        className="rounded bg-gray-300 focus:outline-none ring-gray-700 ring-2 p-2 hover:bg-gray-400 transition-color duration-200"
        onClick={() => handleClick(true)}
      >
        {t("filters.reset")}
      </button>
      <button
        className="rounded bg-white focus:outline-none ring-gray-200 ring-2 p-2 hover:bg-gray-200 transition-color duration-200"
        onClick={() => handleClick()}
      >
        {t("filters.apply")}
      </button>
    </div>
  );
};

export default FilterButtons;
